import Api from "../apiService";

class ActivityLogApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/activity_logs`,
      params,
      Api.authHeaders()
    );
  }

  availableFilters(companyId) {
    return Api.getRequest(
      `companies/${companyId}/activity_logs/available_filters`,
      {},
      Api.authHeaders()
    );
  }
}

export default new ActivityLogApi();
